module.exports = __webpack_public_path__ + "static/media/20210409_182327_083_IMG_0040.e35bcaf5.jpg";